module.exports = require("core-js/library/fn/object/create");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/core-js/object/create.js
// module id = 150
// module chunks = 35783957827783 70144966829960 114276838955818 198517197184460